export default function guard(to, from, next) {
    const token = localStorage.getItem('_token');
    if(token) {
        next();
    } 
    else {
        next('/login');
    }
}